import { connect } from "react-redux";
import styles from "./HomeProducts.module.css";
import * as actions from "../../store/actions/index";
import Spinner from "../Spinner/Spinner";
import { useEffect, useState } from "react";
import FlexContainerNoWrap from "../UI/FlexContainerNoWrap/FlexContainerNoWrap";
import ProductCard from "../ProductCard/ProductCard";
import SlickCarousel from "../UI/SlickCarousel/SlickCarousel";
import Banner1 from "../Banner/Banner1";
const Cards = (props) => {
  let isProductsLoaded = props.productData !== null;
  let isHomeSectionLoaded = props.homeSections.length !== 0;
  let isBannerLoaded = props.bannerData !== null;
  let isClientLoaded = props.clientData !== null;
  let [fetchSectionsOnce, setFetchSection] = useState(false);

  useEffect(() => {
    // if (!isProductsLoaded) {
    //   console.log("home products request sent to server");
    //   //   props.fetchHomeProducts()
    //   props.fetchHomeSection()
    // }
    if (!fetchSectionsOnce) {
      console.log("home products request sent to server");

      props
        .fetchHomeSection()
        .then(() => {
          setFetchSection(true);
        })
        .catch((err) => {
          setFetchSection(false);
        });
    }
    if (!isBannerLoaded) {
      props.fetchBanner();
    }

    if (!isClientLoaded) {
      props.fetchClient();
    }
  }, []);

  useEffect(() => {
    let homeSections = props.homeSections;
    if (homeSections.length && fetchSectionsOnce) {
      homeSections.map((section) => {
        if (section.visible) {
          props.fetchSectionProductsFromArrayOfIds(
            section.id,
            section.products
          );
        }
      });
    }
  }, [props.homeSections, fetchSectionsOnce]);

  const getSlidesToShow = (sectionProducts) => {
    let innerwidth = window.innerWidth;
    let slidesToShow = 4;
    slidesToShow = sectionProducts.length <= 4 ? sectionProducts.length : 4;
    if (innerwidth <= 540) {
      //iphone 6/7/8 plus
      slidesToShow = 2;
    } else if (innerwidth > 540 && innerwidth <= 768) {
      //surface duo, ipad
      slidesToShow = 3;
    }

    return slidesToShow;
  };
  const getSections = (index1, index2) => {
    try {
      let sections = [];
      let homeSections = props.homeSections;
      let homeSectionProducts = props.homeSectionProducts;
      let homeSectionKeys = Object.keys(homeSectionProducts);
      if (homeSectionKeys.length) {
        homeSectionKeys = homeSectionKeys.slice(index1, index2);
        homeSectionKeys.map((sectionKey) => {
          let section = homeSections.filter((sec) => sec.id == sectionKey)[0];
          let sectionTitle = section.title;
          let sectionSeeAllUrl = section.seeAllUrl;
          let sectionProducts = homeSectionProducts[sectionKey];
          sections.push(
            <div>
              <div
                className="d-flex"
                style={{
                  alignItems: "baseline",
                  justifyContent: "space-between",
                }}
              >
                <h3>{sectionTitle}</h3>
                {sectionSeeAllUrl && (
                  <div style={{ paddingRight: "10px" }}>
                    <button
                      className="btn btn-light float-right border-white rounded"
                      onClick={() => (window.location.href = sectionSeeAllUrl)}
                    >
                      View All
                    </button>
                  </div>
                )}
              </div>
              <div>
                <SlickCarousel
                  key={sectionKey}
                  slidesToShow={getSlidesToShow(sectionProducts)}
                >
                  {sectionProducts.map((product) => (
                    <FlexContainerNoWrap>
                      <ProductCard product={product} key={product.id} />
                    </FlexContainerNoWrap>
                  ))}
                </SlickCarousel>
              </div>
            </div>
          );
        });

        return sections;
      }
    } catch (error) {
      return [];
    }
  };
  const getBanners = (index1, index2) => {
    try {
      let banners = [];
      let bannerData = props.bannerData;
      if (bannerData && bannerData.length) {
        bannerData = bannerData.slice(index1, index2);

        bannerData.map((banner, index) => {
          banners.push(
            <Banner1 banner={banner} key={index + Math.random() * 10000} />
          );
        });
      }
      //   console.log(banners)
      return banners;
    } catch (error) {
      return [];
    }
  };
  if (props.loading) {
    return (
      <div className={styles.Spinner}>
        <Spinner />
      </div>
    );
  }

  //   if (!isHomeSectionLoaded) {
  //     return null;
  //   }

  return (
    <div className="container container-md" style={{ padding: "20px" }}>
      {/* <FlexContainer>
        {props.productData.map((product) => (
          <>
            <ProductCard product={product} key={product.id} />
          </>
        ))}
      </FlexContainer> */}
      {/* {Object.keys(props.homeSectionProducts).length ? getSections() : null} */}
      {getSections(0, 2)}
      {getBanners(0, 1)}
      {getSections(2, 3)}
      {getBanners(1, 2)}
      {getSections(3, 10)}
      {getBanners(2, 10)}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    productData: state.homeProducts.productData,
    homeSections: state.homeProducts.homeSections,
    homeSectionProducts: state.homeProducts.homeSectionProducts,
    loading: state.homeProducts.loading,
    bannerData: state.banner.bannerData,
    clientData: state.client.clientData,
    userId: state.auth.userId,
    wishlist: state.account.wishlist,
    user: state.auth.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchHomeProducts: () => dispatch(actions.fetchHomeProducts()),
    fetchHomeSection: () => dispatch(actions.fetchHomeSectionsClient()),
    fetchBanner: () => dispatch(actions.fetchBanner()),
    fetchClient: () => dispatch(actions.fetchClients()),
    fetchSectionProductsFromArrayOfIds: (sectionId, productIds) =>
      dispatch(
        actions.fetchSectionProductsFromArrayOfIds(sectionId, productIds)
      ),
    onFetchWishlist: (userId) => dispatch(actions.onFecthWishlist(userId)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Cards);
